import {
  SALON_HOME_PATH,
  SALON_HUB_PATH,
  SALON_SERVICE_LOBBY_PATH,
  SALON_START_PATH,
} from '../config/salonApp';
import { clearAllGuestKioskState } from '../../face-identity/utils/faceIdentityApi';
import { clearCache } from './dataCache';
import { getApiBaseUrl } from './apiConfig';
import { clearSalonFaceSession } from './salonFaceSession';
import { clearSkinFlowState } from './skinFlowState';
import { finalizeCustomerSession, getSessionId } from './sessionManager';

import { isSalonDeskMode } from './salonKioskMode';
import { SALON_GUEST_INTENT_PATH } from '../config/salonApp';
import { PRESENTATION_HUB_PATH } from '../../presentation/presentationConfig';
import { isPresentationMode } from '../../presentation/presentationSession';

export { SALON_START_PATH, SALON_HUB_PATH, SALON_HOME_PATH, SALON_SERVICE_LOBBY_PATH, SALON_GUEST_INTENT_PATH };

/** Stylist salon app home — customer queue (walk-in kiosk uses guest-intent via explicit link). */
export function resolveSalonHomePath() {
  if (isSalonDeskMode()) return SALON_SERVICE_LOBBY_PATH;
  return SALON_SERVICE_LOBBY_PATH;
}

/** Analysis experience hub (skin/hair/makeup tiles) — presentation demo vs live hub. */
export function resolveExperienceHubPath(fallback = SALON_HUB_PATH) {
  if (isPresentationMode()) return PRESENTATION_HUB_PATH;
  return fallback || SALON_HUB_PATH;
}

/** Home from analysis modules: stylist desk → service lobby; guest kiosk → experience hub. */
export function resolveAnalysisFlowHomePath() {
  if (isSalonDeskMode()) return resolveSalonHomePath();
  return resolveExperienceHubPath(SALON_HUB_PATH);
}

/**
 * End the current skin-analysis guest, clear local leftovers, and open the
 * salon hub Welcome landing so a new user can start check-in + experience pick.
 *
 * @param {import('react-router-dom').NavigateFunction} navigate
 * @param {{ sessionId?: string|null, token?: string|null, apiBaseUrl?: string|null, replace?: boolean }} [options]
 */
export async function goSalonHubForNewUser(navigate, options = {}) {
  const sessionId = options.sessionId || getSessionId() || null;
  const token = options.token || null;
  const apiBaseUrl = options.apiBaseUrl ?? getApiBaseUrl() ?? '';
  const replace = options.replace !== false;

  if (sessionId) {
    await finalizeCustomerSession(apiBaseUrl, sessionId, token);
    try {
      clearCache(sessionId);
    } catch {
      /* ignore */
    }
    clearSkinFlowState(sessionId);
  }

  clearSalonFaceSession();
  clearAllGuestKioskState();

  if (typeof navigate === 'function') {
    navigate(resolveAnalysisFlowHomePath(), { replace, state: {} });
  }
}
